/**
 * Ryan O'Dowd
 * 2023-01-28
 * © Copyright 2023 Oakwood Software Consulting, Inc. All Rights Reserved.
 */

const getStyles = ({colors}) => {
  return {
    container: {
      display: 'flex',
      justifyContent: 'center',
      alignItems: 'center',
      backgroundColor: colors.warnIncorrect,
      padding: 8,
    },
    text: {
      width: '100%',
      textAlign: 'center',
      color: colors.black,
    },
  };
};

export default getStyles;
